import { ImageOff } from 'lucide-react'
import type { ReactNode } from 'react'

/**
 * A foto da peça, do tamanho de uma unha.
 *
 * O balcão vende peça parecida com peça: duas tampas de vidro cujo nome difere
 * numa letra. A foto é o que confirma que o item lançado é o que está na mão —
 * e por isso ela fica na linha da venda, não a um clique de distância.
 *
 * Quem não tem foto ganha um quadro vazio e não um espaço em branco: a coluna
 * continua alinhada, e "este produto não tem foto" é uma informação, enquanto
 * uma célula vazia parece a foto que não carregou.
 */
export const LineThumb = ({
  url,
  description,
}: {
  url: string | null
  description: string
}): ReactNode =>
  url === null ? (
    <span
      aria-hidden="true"
      className="flex h-10 w-10 items-center justify-center rounded-(--radius-sm) border border-dashed border-(--border-subtle) text-(--text-muted)"
    >
      <ImageOff className="h-4 w-4" />
    </span>
  ) : (
    <img
      src={url}
      alt={`Foto de ${description}`}
      loading="lazy"
      className="h-10 w-10 rounded-(--radius-sm) border border-(--border-subtle) object-cover"
    />
  )
